import React, { useState } from "react";
import styled from "styled-components";
import { getHeaderTheme } from "../config/headerTheme";
import { QUICK_REPLY_CATEGORIES } from "../features/quiz/constants/quickReplies";

export default function QuickReplyCategories({ onSelectQuestion, disabled = false }) {
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  const selectedCategory = QUICK_REPLY_CATEGORIES.find(
    (c) => c.id === selectedCategoryId
  );

  const handleBack = () => setSelectedCategoryId(null);

  return (
    <Container>
      {!selectedCategory ? (
        <CategoriesList>
          {QUICK_REPLY_CATEGORIES.map((cat) => (
            <CategoryCard
              key={cat.id}
              onClick={() => setSelectedCategoryId(cat.id)}
              type="button"
            >
              <CategoryLabel>{cat.label}</CategoryLabel>
              <CategoryDescription>{cat.description}</CategoryDescription>
            </CategoryCard>
          ))}
        </CategoriesList>
      ) : (
        <QuestionsView>
          <BackButton onClick={handleBack} type="button">
            ← Volver
          </BackButton>
          <CategoryTitle>{selectedCategory.label}</CategoryTitle>
          <QuestionsList>
            {selectedCategory.questions.map((q) => (
              <QuestionButton
                key={q.id}
                onClick={() => onSelectQuestion(q.userMessage)}
                disabled={disabled}
                type="button"
              >
                {q.label}
              </QuestionButton>
            ))}
          </QuestionsList>
        </QuestionsView>
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

const CategoriesList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.6rem;

  @media (min-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const theme = getHeaderTheme();

const CategoryCard = styled.button`
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.9rem 1rem;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-left: 4px solid ${theme.accent};
  border-radius: 12px;
  text-align: left;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);

  &:hover:not(:disabled) {
    background: ${theme.primaryLight};
    transform: scale(1.01);
    box-shadow: 0 4px 10px ${theme.primaryTransparent};
  }

  &:active:not(:disabled) {
    transform: scale(0.99);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const CategoryLabel = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
`;

const CategoryDescription = styled.span`
  font-size: 0.85rem;
  color: #6b7280;
`;

const QuestionsView = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const BackButton = styled.button`
  align-self: flex-start;
  padding: 0.4rem 0.8rem;
  background: transparent;
  border: 1px solid #d1d5db;
  border-radius: 999px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #f3f4f6;
    border-color: #9ca3af;
  }
`;

const CategoryTitle = styled.h4`
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
`;

const QuestionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const QuestionButton = styled.button`
  padding: 0.8rem 1rem;
  background: #fafafa;
  border: 1px solid #e5e7eb;
  border-left: 3px solid ${theme.accent};
  border-radius: 8px;
  font-size: 0.95rem;
  color: #374151;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover:not(:disabled) {
    background: ${theme.primaryLight};
    border-color: ${theme.accent};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
